/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersModule
 * Purpose		: Module for Suppliers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { SuppliersService } from './Suppliers.service';
import { SuppliersListComponent } from './SuppliersList.component';
import { SuppliersSearchComponent } from './SuppliersSearch.component';
import { SuppliersAddComponent } from './SuppliersAdd.component';
import { SuppliersEditComponent } from './SuppliersEdit.component';
import { SuppliersDetailsComponent } from './SuppliersDetails.component';

import { SuppliersRoutingModule } from './Suppliers-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    SuppliersRoutingModule
  ],
  declarations: [
    SuppliersListComponent,
	SuppliersSearchComponent,
    SuppliersEditComponent,
    SuppliersAddComponent,
	SuppliersDetailsComponent
  ],
  providers: [
    SuppliersService
  ]
})

export class SuppliersModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Suppliers/Suppliers.module.ts